<template>
    <article class="h-12 md:h-fit md:px-3 py-2 md:flex md:flex-col md:justify-center">
        <div class="h-full md:h-fit flex flex-row md:flex-col gap-4 md:gap-2 items-center md:items-start">
            <h1 class="md:hidden leading-none font-grotesk font-light">
                {{ currentGroup?.name }}.
            </h1>

            <h2 class="md:hidden text-xs sm:text-base tracking-tight md:tracking-normal font-freizeit md:font-light">
                {{ descriptionCopy }}
            </h2>

            <div class="hidden md:!flex flex-col gap-2 font-freizeit">
                <selection-description class="text-base font-freizeit font-extralight tracking-normal" />

                <div class="my-2 lg:my-4 border-t border-black w-20"></div>

                <h4
                    v-if="bottlePrice"
                    class="text-3xl font-freizeit"
                >
                    ${{ bottlePrice }}
                </h4>
            </div>
        </div>
    </article>
</template>

<script>
    import allStores from '../stores/all';

    import SelectionDescription from './SelectionDescription.vue';

    export default {
        mixins: [allStores],

        components: {
            SelectionDescription,
        },

        computed: {
            currentStep() {
                return this.appStore.currentStep;
            },

            allGroups() {
                return this.customizerStore.viewController?.blueprint.groups;
            },

            filteredGroups() {
                return this.allGroups?.filter((group) => group.custom['oe-hide'] !== 'true');
            },

            currentGroup() {
                const groupName = this.currentStep.split('select')[1];
                const result = this.filteredGroups?.find((group) => group.name === groupName);

                return result;
            },

            descriptionCopy() {
                return this.currentGroup?.placements?.[0].description;
            },

            bottlePrice() {
                return this.customizerStore.statePrice?.toFixed(0);
            },
        },
    };
</script>
